import React, { createContext, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
//components
import { toastify } from 'components/Toastify/utils';
//services
import ProductService from 'services/product.service';
import QuoteService from 'services/quote.service';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//interfaces
import { TabOpenProps } from 'models/QuoteDetail';
import { OutPortfolioContextProviderProps, OutPortfolioContextType } from './interface';

export const OutPortfolioContext = createContext({} as OutPortfolioContextType);

export function OutPortfolioContextProvider(props: OutPortfolioContextProviderProps) {
  const {
    quoteId,
    children,
    productCode,
    portfolioDb,
    changeToggle,
    sequenceNumber,
    buyerIdentifier,
    distributionCenterSelected
  } = props;
  const { setQuoteDetail, quoteDetail } = useDetailsQuoteContext();

  const [disabled, setDisabled] = useState(false);
  const [portfolio, setPortfolio] = useState(portfolioDb);

  const _productService = new ProductService();
  const _quoteService = new QuoteService();

  const dispatch = useDispatch();

  const handleOutPortfolio = async () => {
    const oldPortfolio = portfolio;

    setDisabled(true);
    setPortfolio(!portfolio);

    const response = await _productService.setProdutcOutPortfolio(buyerIdentifier, productCode, quoteId, sequenceNumber);

    if (response.status !== 200) {
      setPortfolio(oldPortfolio);
      toastify.error("Não foi possível atualizar o item");
    }

    reloadTabs(quoteId);
  };

  const setCurrentTab = (indexTabProp: number) => {
    if (indexTabProp !== -1)
      dispatch({ type: 'SET_CURRENT_TAB_PAGE', data: { currentNameTab: "outPortfolio", currentTabPage: indexTabProp } });
    else
      dispatch({ type: 'SET_CURRENT_TAB_PAGE', data: { currentNameTab: "outPortfolio", currentTabPage: 0 } });

    setDisabled(false);
  };

  const reloadTabs = async (quoteIdReload: string) => {
    let result;
    if (quoteDetail?.integrationMessages && quoteDetail?.integrationMessages?.length > 0) {
      result = await _quoteService.quoteDetailsWithCD(quoteIdReload);

      if (result?.data && !result?.error && quoteDetail) {
        changeToggle(sequenceNumber, result.data.distributionCentersList);
        setQuoteDetail({ ...quoteDetail, distributionCentersList: result.data.distributionCentersList, renderNewTabs: true });

        const indexTab = result.data.distributionCentersList.findIndex((tab: TabOpenProps) => tab.distributionCenter === distributionCenterSelected);
        setCurrentTab(indexTab);
      }
    }
    else {
      result = await _quoteService.quoteDetails(quoteIdReload);

      if (result?.data && !result?.error && quoteDetail) {
        changeToggle(sequenceNumber, result.data.tabs);
        setQuoteDetail({ ...quoteDetail, tabs: result.data.tabs, renderNewTabs: true });

        const indexTab = result.data.tabs.findIndex((tab: TabOpenProps) => tab.segmentTab === distributionCenterSelected);
        setCurrentTab(indexTab);
      }
    }


  };

  return (
    <OutPortfolioContext.Provider value={{
      disabled,
      portfolio,
      handleOutPortfolio
    }}>
      {children}
    </OutPortfolioContext.Provider>
  );
}

export const useOutPortfolioContext = () => {
  return useContext(OutPortfolioContext);
};